import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

export interface LandingSeoData {
  title: string;
  description: string;
  ogTitle?: string;
  ogDescription?: string;
}

/**
 * Servicio SEO opcional. Usa únicamente Title/Meta de Angular (no toca index.html).
 * Es responsabilidad del componente raíz del proyecto anfitrión decidir si invoca
 * este servicio (por ejemplo, solo cuando la ruta activa es la de esta landing),
 * para no pisar el SEO de otras rutas del proyecto destino.
 */
@Injectable()
export class LandingSeoService {
  constructor(
    private readonly title: Title,
    private readonly meta: Meta,
  ) {}

  apply(data: LandingSeoData): void {
    this.title.setTitle(data.title);
    this.meta.updateTag({ name: 'description', content: data.description });
    this.meta.updateTag({ property: 'og:title', content: data.ogTitle ?? data.title });
    this.meta.updateTag({ property: 'og:description', content: data.ogDescription ?? data.description });
  }
}
